module.exports = __webpack_public_path__ + "cf701b8e8c77f03dd8abe7eb94691376.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/nature/Snow1.jpg
// module id = 3358
// module chunks = 0